/**
 * Safely navigates back in browser history if the user reached the current page
 * from within the application (internal SPA history). If the user arrived
 * directly from an external source (email, bookmark, direct URL, etc.),
 * it falls back to the specified fallbackPath (default: "/").
 *
 * @param {Function} navigate - React Router's navigate function
 * @param {string} [fallbackPath="/"] - Fallback route when no internal history exists
 */
export const handleSmartBack = (navigate, fallbackPath = "/") => {
  // React Router v6 tracks history depth in window.history.state.idx (0 on initial entry)
  const isInternalNavigation =
    window.history.state &&
    typeof window.history.state.idx === "number" &&
    window.history.state.idx > 0;

  if (isInternalNavigation) {
    navigate(-1);
  } else {
    navigate(fallbackPath);
  }
};
